<div class="content">
  @if (!contentFullyLoaded) {
    <app-mat-spinner-overlay overlay="overlay"></app-mat-spinner-overlay>
  }

  <h1 mat-dialog-title>
    {{'What\'s New' | translate}}

    <button mat-mini-fab
      color="primary"
      mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <div class="navigation">
    @if (hasMultipleContents()) {
      <button [disabled]="!hasPreviousContent()"
        class="prev"
        mat-icon-button
        color="primary"
        (click)="loadPreviousContent()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    }

    @if (contentFetched) {
      <iframe
        [src]="currentContent"
        title="Iframe Example"
        allowfullscreen
      (load)="contentLoadedInIframe($event)"></iframe>
    }

    @if (hasMultipleContents()) {
      <button [disabled]="!hasNextContent()"
        mat-icon-button
        color="primary"
        class="next"
        (click)="loadNextContent()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>

  @if (contentFetched && hasMultipleContents()) {
    <div class="counter"
      >
      {{currentContentIndex + 1}} / {{whatsNewContents.contents.length}}
    </div>
  }
</div>
